var link_viewer_default = {
  "fontElementMap": "IrOda",
  "link": "OfpAK",
  "linkInEditor": "_1donY",
  "linkInViewer": "PB45x",
  "toolbarUrlContainer": "SWcUx",
  "toolbarUrl": "q9XGo",
  "toolbarUrlAnchor": "qbSWe"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
